import type { ReactNode } from 'react';

// 法的文書ページ共通のレイアウト。タイトル・制定日を付与する。
export default function LegalLayout({
  title,
  enacted,
  children,
}: {
  title: string;
  enacted?: string;
  children: ReactNode;
}) {
  return (
    <div className="container">
      <article className="legal">
        <h1>{title}</h1>
        {enacted && <p className="legal__updated">制定日: {enacted}</p>}
        {children}
      </article>
    </div>
  );
}
